import React from "react";
import PropTypes from "prop-types";
import i18n from "lib/i18n";
import FormFieldset from "components/FormFieldset";
import { FormControlLabel, Checkbox, Typography } from "@theconversation/ui";


const GiftAidSection = ({ active, giftAid, onChange }) => {
  const handleChange = () => {
    onChange({ giftAid: !giftAid });
  };

  return (
    <div id="gift-aid" className="base" >
      <fieldset id="gift_aid">
        <FormFieldset>
          <Typography variant="h6">{i18n.t("donation.heading.gift_aid")}</Typography>
        </FormFieldset>

        <FormFieldset>
          <Typography variant="subtitle1">{i18n.t("donation.hint.gift_aid_message")}</Typography>

          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={giftAid}
                disabled={!active}
                id="donation_gift_aid"
                name="donation[gift_aid]"
                onChange={handleChange}
                value="true"
              />
            }
            label={i18n.t("donation.label.gift_aid_checkbox")}
          />

          <Typography variant="subtitle2">{i18n.t("donation.hint.gift_aid_caveat")}</Typography>
        </FormFieldset>
      </fieldset>
    </div>
  );
};

GiftAidSection.defaultProps = {
  active: true,
  giftAid: false,
  onChange: () => {},
};

GiftAidSection.propTypes = {
  active: PropTypes.bool,
  giftAid: PropTypes.bool,
  onChange: PropTypes.func,
};

export default React.memo(GiftAidSection);
